import React, { useEffect }  from 'react';
import PageLayout from '../components/Layouts/PageLayout';
import { MainData } from '../Data/MainData';
import { Link, Navigate, useLocation, useNavigate, useParams } from 'react-router-dom';
import { getLanLoc } from '../components/Functions/LangFunc';
import styled from 'styled-components';
import PageBuilder from '../components/PageBuilder/PageBuilder';
import { GetDataPromise, PostDataPromise } from '../components/Functions/SendingData';
import { apiMain } from '../App';
import { LoadingFull } from '../components/LoadingFull';
import { IconRouting } from '../Assets/panels/IconRouting';
import { IconBuilding } from '../Assets/contacts/IconBuilding';
import { IconLocation } from '../Assets/contacts/IconLocation';
import { IconAgency } from '../Assets/contacts/IconAgency';
import { DictioneryPanel } from '../Data/DictioneryPanel';
import { formatPrice } from '../components/Functions/Price';
import { TextInputWTitle } from '../components/Inputs/TextInputWTitle';
import { AgeTypeV2Selector } from '../components/Inputs/AgeTypeV2Selector';
import { DateInputWTitle, langDateChangeWithLan } from '../components/Inputs/DateInputWTitle';
import { TextBtn2 } from '../components/Inputs/TextBtn2';
import { SelectInputWTitle } from '../components/Inputs/SelectInputWTitle';
import { paramsToObject } from '../components/Functions/Helpers';
import { CountriesSelector } from '../components/Inputs/CountriesSelector';
import { CitiesSelector } from '../components/Inputs/CitiesSelector';
import { TagsV2Selector } from '../components/Inputs/TagsV2Selector';
import { TextInputBig } from '../components/Inputs/TextInputBig';

const Styles = styled.div`
  display: flex;
  flex-direction: column;
  .over-tour {
    width: calc(100% - calc(var(--universal-pad) * 2) - 0);
    margin: 1rem var(--universal-pad) 1rem;
    background-color: var(--n-grey-0);
    box-shadow: 0px 4px 50px -16px #00000028;
    padding: 1.25rem;
    border-radius: var(--border-radius-32);
    position: relative;
    display: flex;
    align-items: center;
    gap: 1.5rem;
    .base {
      width: calc(70% - 1rem);
      display: flex;
      flex-direction: column;
      gap: 0.5rem;
      .title1 {
        font-size: 1.5rem;
        font-weight: 700;
      }
      .desc {
        text-decoration: none;
        color: inherit;
        display: flex;
        gap: 0.5rem;
        font-size: 0.9rem;
        font-weight: 600;
        &.big {
          margin-top: 0.3rem;
          font-size: 1.1rem;
        }
        .desc-link {
          color: var(--c-main);
        }
        svg {
          fill: var(--n-grey-2);
          width: 32px;
          height: 32px;
          display: block;
        }
        .text {
          width: calc(100% - 32px - 0.5rem);
          white-space: pre-line;
        }
      }
    }
    .image {
      width: 30%;
      max-width: 300px;
      aspect-ratio: 1.8;
      border: 1px solid var(--n-grey-1);
      border-radius: var(--border-radius-3);
      overflow: hidden;
      position: relative;
      background-color: var(--n-grey-01);
      .icon-def {
        position: absolute;
        top: calc(50% - 24px);
        right: calc(50% - 24px);
        display: block;
        fill: var(--n-grey-2);
        z-index: 1;
      }
      img {
        position: relative;
        z-index: 2;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .end {
      display: flex;
      justify-content: flex-end;
      gap: 1.25rem;
      .social {
        border-radius: 100px;
        border: 1px solid var(--n-grey-1);
        background-color: var(--n-grey-01);
        padding: 0.87rem;
        svg {
          display: block;
        }
      }
    }
  }
  .buying-forms {
    width: calc(100% - calc(var(--universal-pad) * 2) - 0);
    margin: 1rem var(--universal-pad) 1rem;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 1rem;
    .form-1 {
      grid-column: 3 span;
      background-color: var(--n-grey-0);
      box-shadow: 0px 4px 50px -16px #00000028;
      padding: 1.25rem;
      border-radius: var(--border-radius-32);
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 1rem;
      .title {
        grid-column: 2 span;
        font-size: 1.2rem;
        font-weight: 700;
      }
      .line {
        grid-column: 2 span;
        width: 100%;
        height: 1px;
        background-color: var(--n-grey-1);
      }
    }
    .form-2 {
      grid-column: 1 span;
      background-color: var(--n-grey-0);
      box-shadow: 0px 4px 50px -16px #00000028;
      padding: 1.25rem;
      border-radius: var(--border-radius-32);
      display: flex;
      flex-direction: column;
      align-self: flex-start;
      position: sticky;
      top: 70px;
      .tour-price-data {
        display: flex;
        flex-direction: column;
        gap: 0.5rem;
        &.small {
          /* warning */
          font-size: 0.8rem;
          font-weight: 500;
          /* color: var(); */
          margin: 0 0 1rem;
        }
        .total {
          margin: 1rem 0;
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-size: 1.05rem;
          font-weight: 700;
          .title {
            color: var(--n-grey-2);
          }
          .value {
            direction: ltr;
            color: var(--c-main);
          }
        }
      }
    }
  }
  @media screen and (max-width: 850px) {
    .over-tour {
      padding: 1rem;
      flex-direction: column;
      align-items: normal;
      gap: 1rem;
      .image {
          width: 100%;
          max-width: none;
          aspect-ratio: 2.5;
      }
      .expand {
          display: none;
      }
    }
    .buying-forms {
      grid-template-columns: repeat(1, 1fr);
      .form-1 {
        grid-column: 1 span;
        grid-template-columns: repeat(1, 1fr);
        gap: 0;
        .title {
          grid-column: 1 span;
        }
        .line {
          grid-column: 1 span;
        }
      }
    }
  }
`

export default function BuyTourReqPage (props){
  const location = useLocation();
  const navigate = useNavigate();
  const [data, setData] = React.useState(null);
  const [loading, setLoading] = React.useState(true);
  const [dialogLoading, setDialogLoading] = React.useState(false);
  const [dialogError, setDialogError] = React.useState({});
  const [dataForm, setDataForm] = React.useState({
    Adult_Count: 1,
  });
  const onChange = (e) => {
      const value = e.target.value;
      const name = e.target.name;
      let temp = {...dataForm};
      temp[name] = value;
      setDataForm(temp);
  }
  const onChangeNum = (e) => {
    const value = e.target.value;
    const name = e.target.name;
    let temp = {...dataForm};
    temp[name] = "";
    if(isNaN(parseInt(value)) === false){
      temp[name] = parseInt(value);
    }
    setDataForm(temp);
  }
  let {isEn: lan, isSet: isSetLan} = getLanLoc(location.pathname);

  const sendData = async () => {
    let keys = Object.keys(dataForm);
    let errors = {};
    let formData = new FormData();
    formData.append("U_CODE", props.user.U_CODE);
    
    let keylistReq = [
      "Tour_Notify_Mobile",
      "Tour_Notify_User_Name",
      "Country_Id",
      "City_Id",
      "Tour_Date",
      "Tourist_Count",
      "Tour_Notify_Day_Count"
    ]
    for (let i = 0; i < keylistReq.length; i++) {
      const element = keylistReq[i];
      if(keys.findIndex(v => v === element) !== -1){
        formData.append(element, dataForm[element]);
      } else {
          errors[element] = "پر شود"
      }
    }
    let keyListNotReq = [
      "Tour_Notify_Email",
      "Tag_Id",
      "Tour_Notify_Desc"
    ]
    for (let i = 0; i < keyListNotReq.length; i++) {
      const element = keyListNotReq[i];
      if(keys.findIndex(v => v === element) !== -1){
        formData.append(element, dataForm[element]);
      }
    }
    if(Object.keys(errors).length){
      setDialogError(errors)
      return;
    }
    setDialogLoading(true);
    setDialogError({})

    let res = await PostDataPromise(`${apiMain}/api/v2/tour/V2_tour_notify/insert`, formData);
    let parsed = JSON.parse(res);
    if(!parsed.status || parsed.status === "error"){
      setDialogLoading(false);
      // setDialogError(parsed.data);
      return;
    }
    setDialogLoading(false)
    navigate(`/${(lan ? "en" : "fa")}/buy-tour-success`);
  }
  if(!props.user.API_TOKEN){
    return (
      <Navigate replace={true} to={`/${(lan ? "en" : "fa")}/tour`}/>
    )
  }
  

  let lang = lan ? {...MainData.dict[0]} : {...MainData.dict[1]};
  return (
    <PageLayout 
      {...props} 
      language={lan ? {...MainData.dict[0]} : {...MainData.dict[1]}} 
      dict={MainData.dict} 
      mainLogo={MainData.mainLogo} 
      texts={MainData.texts} 
      nav={MainData.nav} 
      footer={MainData.footer} 
      login={MainData.login}
    >
      <Styles>
        <div className="navpad"></div>
        <div className='buying-forms'>
            <div className='form-1'>
              <div className='title'>
              {DictioneryPanel.touristsDict.personMainInfo[lang.filename]}
              </div>
              <TextInputWTitle
                  title={DictioneryPanel.touristsDict.personMobile[lang.filename]}
                  name={"Tour_Notify_Mobile"}
                  value={(dataForm.Tour_Notify_Mobile) ? dataForm.Tour_Notify_Mobile : ""}
                  onchange={onChange}
                  error={(dialogError.Tour_Notify_Mobile) ? dialogError.Tour_Notify_Mobile : ""}
                  lan={(lang.filename !== "fa") ? true : false}
              />
              <TextInputWTitle
                  title={DictioneryPanel.touristsDict.personEmail[lang.filename]}
                  name={"Tour_Notify_Email"}
                  value={(dataForm.Tour_Notify_Email) ? dataForm.Tour_Notify_Email : ""}
                  onchange={onChange}
                  error={(dialogError.Tour_Notify_Email) ? dialogError.Tour_Notify_Email : ""}
                  lan={(lang.filename !== "fa") ? true : false}
              />
              <TextInputWTitle
                  title={DictioneryPanel.touristsDict.personFName[lang.filename]}
                  name={"Tour_Notify_User_Name"}
                  value={(dataForm.Tour_Notify_User_Name) ? dataForm.Tour_Notify_User_Name : ""}
                  onchange={onChange}
                  error={(dialogError.Tour_Notify_User_Name) ? dialogError.Tour_Notify_User_Name : ""}
                  lan={(lang.filename !== "fa") ? true : false}
              />
              <div></div>

              {/* 
              "Country_Id",
              "City_Id",
              "Tag_Id",
              "Tour_Date",
              "Tour_Notify_Date",
              "Tour_Notify_Desc",
              "Tour_Notify_Email",
              "Tour_Notify_Id",
              "Tour_Notify_Mobile",
              "Tour_Notify_User_Name",
              "Tourist_Count",
              */}
              
              <div className='line'></div>
              <CountriesSelector
                  title={
                    DictioneryPanel.dashboardDict.countryDest[lang.filename]
                  }
                  name={"Country_Id"}
                  value={(dataForm.Country_Id) ? dataForm.Country_Id : ""}
                  onchange={onChange}
                  error={(dialogError.Country_Id) ? dialogError.Country_Id : ""}
                  lan={(lang.filename !== "fa") ? true : false}
              />
              <CitiesSelector
                  title={
                    DictioneryPanel.dashboardDict.cityDest[lang.filename]
                  }
                  Country_Id={(dataForm.Country_Id) ? dataForm.Country_Id : ""}
                  name={"City_Id"}
                  value={(dataForm.City_Id) ? dataForm.City_Id : ""}
                  onchange={onChange}
                  error={(dialogError.City_Id) ? dialogError.City_Id : ""}
                  lan={(lang.filename !== "fa") ? true : false}
              />
              <DateInputWTitle
                  title={DictioneryPanel.packagesDict.startTour[lang.filename]}
                  name={"Tour_Date"}
                  value={(dataForm.Tour_Date) ? dataForm.Tour_Date : ""}
                  onchange={onChange}
                  error={(dialogError.Tour_Date) ? dialogError.Tour_Date : ""}
                  lan={(lang.filename !== "fa") ? true : false}
                  changeDate={true}
              /> 
              <TextInputWTitle
                  title={
                    DictioneryPanel.packagesDict.dayCount[lang.filename]
                  }
                  name={"Tour_Notify_Day_Count"}
                  value={(dataForm.Tour_Notify_Day_Count) ? dataForm.Tour_Notify_Day_Count : "0"}
                  onchange={onChangeNum}
                  error={(dialogError.Tour_Notify_Day_Count) ? dialogError.Tour_Notify_Day_Count : ""}
                  lan={(lang.filename !== "fa") ? true : false}
              />
              <TagsV2Selector
                title={
                  DictioneryPanel.packagesDict.tags[lang.filename]
                }
                name={"Tag_Id"}
                value={(dataForm.Tag_Id) ? dataForm.Tag_Id : ""}
                onchange={onChangeNum}
                error={(dialogError.Tag_Id) ? dialogError.Tag_Id : ""}
                lan={(lang.filename !== "fa") ? true : false}
                first={true}
                search={true}
                add={false}
              />
              <TextInputWTitle
                  title={
                    DictioneryPanel.packagesDict.NumberOf[lang.filename] + " " +
                    DictioneryPanel.packagesDict.passengers[lang.filename]
                  }
                  name={"Tourist_Count"}
                  value={(dataForm.Tourist_Count) ? dataForm.Tourist_Count : "0"}
                  onchange={onChangeNum}
                  error={(dialogError.Tourist_Count) ? dialogError.Tourist_Count : ""}
                  lan={(lang.filename !== "fa") ? true : false}
              />
              <div className='desc' style={{gridColumn: "2 span"}}>
                <TextInputBig
                    title={
                      DictioneryPanel.packagesDict.planDesc[lang.filename]
                    }
                    name={"Tour_Notify_Desc"}
                    value={(dataForm.Tour_Notify_Desc) ? dataForm.Tour_Notify_Desc : ""}
                    onchange={onChange}
                    error={(dialogError.Tour_Notify_Desc) ? dialogError.Tour_Notify_Desc : ""}
                    lan={(lang.filename !== "fa") ? true : false}
                />
              </div>
            </div>
            <div className='form-2'>
              <div className='actions'>
                <TextBtn2
                  text={DictioneryPanel.packagesDict.sendReq[lang.filename]}
                  onclick={sendData}
                  loading={dialogLoading}
                  disabled={dialogLoading}
                  newType={4}
                />
              </div>
            </div>
        </div>
        <div className="navpad"></div>
      </Styles>
    </PageLayout>
  )
}

